import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import NewsList from './NewsList';
import {Link} from "@reach/router";

class HomeNews extends Component{
  render(){

    let items = [];
    this.props.data.items.forEach((item, index) => {
      items.push(<NewsList key={'nw' + index} data={item} />);
    });

    return(
      <>
      <div className="berita-populer">
        <div className="container">
          <h4>Berita Populer</h4>
          <ul>
            {items}
          </ul>
          <Link className="more" to="../news">
            <span>Lihat berita lainnya dari {this.props.nick}</span>
            <span><img src="http://resources.triyakom.com/mini_portal/right-chevron.png" /></span></Link>
        </div>
      </div>
      </>
    );
  }
}

export default HomeNews;
